import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-170803278-1',
  router
})

let app = ''

var firebaseConfig = {
  apiKey: 'AIzaSyC3LIV0XrsUUnqK6uMpoNwHDBkKvYBsajE',
  authDomain: 'lausitz-mit-zukunft.firebaseapp.com',
  databaseURL: 'https://lausitz-mit-zukunft.firebaseio.com',
  projectId: 'lausitz-mit-zukunft',
  storageBucket: 'lausitz-mit-zukunft.appspot.com',
  messagingSenderId: '643780820483',
  appId: '1:643780820483:web:174fe7ab916f0575805836',
  measurementId: 'G-FGT7XY2843'
}

firebase.initializeApp(firebaseConfig)

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})



// WEBPACK FOOTER //
// ./src/main.js